var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredGrinningFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15 11.9239 14.3387 13.1933 13.3064 14.0179C12.5033 13.7485 11.4768 13.5 10.5 13.5C9.5232 13.5 8.49671 13.7485 7.69357 14.0179C6.66132 13.1933 6 11.9239 6 10.5C6 8.01472 8.01472 6 10.5 6C12.9853 6 15 8.01472 15 10.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.5C26 11.9239 25.3387 13.1933 24.3064 14.0179C23.5033 13.7485 22.4768 13.5 21.5 13.5C20.5232 13.5 19.4967 13.7485 18.6936 14.0179C17.6613 13.1933 17 11.9239 17 10.5C17 8.01472 19.0147 6 21.5 6C23.9853 6 26 8.01472 26 10.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13C12.6569 13 14 11.6569 14 10C14 8.34315 12.6569 7 11 7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13Z",
    fill: "#402A32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13C22.6569 13 24 11.6569 24 10C24 8.34315 22.6569 7 21 7C19.3431 7 18 8.34315 18 10C18 11.6569 19.3431 13 21 13Z",
    fill: "#402A32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25C7 25 7 16 7 16H25C25 16 25 25 16 25Z",
    fill: "#BB1D80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5V16H24V16.5C24 17.0523 23.5523 17.5 23 17.5H9C8.44772 17.5 8 17.0523 8 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredGrinningFace);
export default __webpack_public_path__ + "static/media/coloredGrinningFace.2e9c735ec0b3a5d2afc521f36887aa25.svg";
export { ForwardRef as ReactComponent };